import Vue from "vue";
import { replace, forEach, entries, camelCase } from "lodash";

import * as filters from "@/app/filters";

forEach(entries(filters), ([name, filter]) =>
  Vue.filter(camelCase(replace(name, "format", "")), filter)
);
